import React, { useState, useEffect } from "react";

function Gainers({ gainers }) {
  return (
    <div>
      <h3 className="font-bold text-xl text-sm-2xl">Gainers</h3>
      <table className="table text-dark table-striped table-responsive">
        <thead>
          <tr className="mb-2">
            <th></th>
            <th>Name</th>
            <th>Symbol</th>
            <th>Price</th>
            <th>% Change</th>
            <th>$ Volume</th>
          </tr>
        </thead>
        <tbody>
          {gainers.map((data, index) => {
            return (
              <tr key={index} className="mb-2 text-center">
                <td><img alt="coin" src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${data.id}.png`} width="30" height="30"/></td>
                <td>{data.name}</td>
                <td>{data.symbol}</td>
                <td>{data.priceChange.price}</td>
                <td className="text-success">{data.priceChange.priceChange24h}</td>
                <td>{data.priceChange.volume24h}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function Losers({ losers }) {
  return (
    <div>
      <h3 className="font-bold text-xl text-sm-2xl">Losers</h3>
      <table className="table text-dark table-striped table-responsive">
        <thead>
          <tr className="mb-2">
            <th></th>
            <th>Name</th>
            <th>Symbol</th>
            <th>Price</th>
            <th>% Change</th>
            <th>$ Volume</th>
          </tr>
        </thead>
        <tbody>
          {losers.map((data, index) => {
            return (
              <tr key={index} className="mb-2 text-center">
                <td><img alt="coin" src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${data.id}.png`} width="30" height="30"/></td>
                <td>{data.name}</td>
                <td>{data.symbol}</td>
                <td>{data.priceChange.price}</td>
                <td className="text-danger">{data.priceChange.priceChange24h}</td>
                <td>{data.priceChange.volume24h}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}



function MarketCoin() {
  const [gainers, setGainers] = useState([]);
  const [losers, setLosers] = useState([]);
  const [num,setNum]=useState(0)

  function reload(){
    setTimeout(()=>{
      setNum(()=>num+1)
      console.log(num)
    },5000)
  }
  reload();

  useEffect(() => {
    fetch(`https://stoxxboxx.herokuapp.com/gainers-losers`)
    .then(res => res.json())
    .then(data => {
      console.log(data);
      setGainers(data.gainers);
      setLosers(data.losers);
    })
    .catch(error => {
      console.log("Empty Data");
    });
  }, [num]);

  return (
    <div className="bg-light py-5 px-sm-4 px-4">
      <div>
        <Gainers gainers={gainers} />
      </div>
      <hr></hr>
      <div>
        <Losers losers={losers} />
      </div>
      <hr></hr>
    </div>
  );
}

export default MarketCoin;
